'use strict';

//first argument = english yes
//second argument = frenchie

function t() {
  var lang = $('html').attr('lang'),
  lang_position = lang == 'en' ? 0 : 1;
  arguments_length = arguments.length;

  if (arguments_length == 0) {
    return '';
  }
  else if (arguments_length == 1) {
    return arguments[0];
  }
  else if (arguments_length > 1) {
    return arguments[lang_position];
  }
}